import { SerializableObject } from './serializable-object';

export class MobizLocalization extends SerializableObject {
  /**
   * Localization key.
   */
  key: string;

  /**
   * Localized value to represent key in given locale.
   */
  value: string;

  /**
   * Locale identifier.
   */
  locale: string;
}
